import { aludraApi } from 'api/axios'
import { mdl11Urls } from './mdl11.urls'
import { syncRelatedOrderPayment } from './relatedOrderPayment'

export const fullfilmentPlanByDelivery = async payload => {
  return aludraApi.post(mdl11Urls.fullfillmentPlanDispatchUrl, payload)
}

export const creditAccounts = async ({ customerId, companyId }) =>
  aludraApi.get(`${mdl11Urls.creditAccUrl}${customerId}&CompanyId=${companyId}`)

export const allCreditAccounts = async payload => {
  const data = aludraApi.post(mdl11Urls.getAllCreditAccount, payload)
  return data
}

export const updateApprovalSalesOrder = async payload => {
  return aludraApi.post(mdl11Urls.updateApprovalSalesOrder, payload)
}

export const approvalSalesOrder = async DocumentHeaderId => {
  return aludraApi.get(
    mdl11Urls.getApprovallSalesOrder + `?Id=${DocumentHeaderId}`
  )
}

export const searchSalesDocuments = async payload => {
  return aludraApi.post(mdl11Urls.searchSalesDocuments, payload)
}

export const salesRelatedDocuments = async payload => {
  return aludraApi.post(mdl11Urls.salesRelatedDocuments, payload)
}

export const searchQuotes = async payload => {
  return aludraApi.post(mdl11Urls.searchQuotes, payload)
}

export const searchSalesOrders = async payload => {
  return aludraApi.post(mdl11Urls.searchSalesOrders, payload)
}

export const searchDispatches = async payload => {
  const response = await aludraApi.post(mdl11Urls.searchDispatches, payload)
  if (response?.data?.Data?.Results) {
    response.data.Data = response.data.Data.Results
  }
  return response
}

export const updateDocumentStatus = async payload => {
  return aludraApi.post(mdl11Urls.updateDocumentStatus, payload)
}

export const addUpdateSalesDocuments = async payload => {
  const currentPayload = await syncRelatedOrderPayment(payload)
  return aludraApi.post(mdl11Urls.addCotizationURL, currentPayload)
}

export const generatePDF = async payload => {
  return aludraApi.post(mdl11Urls.pdfURL, payload)
}

export const sendEmailQuote = async payload => {
  return aludraApi.post(mdl11Urls.emailURL, payload)
}

export const listSalesAgents = async payload => {
  return aludraApi.post(mdl11Urls.salesAgentsUrl, payload)
}

export const searchSalesDocumentDetail = async payload => {
  return aludraApi.post(mdl11Urls.searchSalesDocumentDetail, payload)
}

export const reasonCancellation = async () => {
  return aludraApi.get(mdl11Urls.ReasonCancellation)
}

export const listChannels = async => {
  return aludraApi.get(mdl11Urls.cannalURL)
}

export const uploadDocumentHistory = async payload => {
  return aludraApi.post(mdl11Urls.documentHistory, payload)
}

export const listODCDocument = async ({ documentTypeId, documentId }) => {
  return aludraApi.get(
    mdl11Urls.getOdcDocument +
      `?documentTypeId=${documentTypeId}&documentId=${documentId}`
  )
}

export const paintingHistoryByCustomerId = async payload => {
  return aludraApi.post(mdl11Urls.paintingHistory, payload)
}

export const searchActivePickingFlowBranches = async payload => {
  return aludraApi.post(
    `${mdl11Urls.billingFlowPickingBranch}/search/active`,
    payload,
    { headers: { 'app-type': 'AB' } }
  )
}

export const searchInactivePickingFlowBranches = async payload => {
  return aludraApi.post(
    `${mdl11Urls.billingFlowPickingBranch}/search/inactive`,
    payload,
    { headers: { 'app-type': 'AB' } }
  )
}

export const addPickingFlowBranches = async payload => {
  return aludraApi.post(`${mdl11Urls.billingFlowPickingBranch}/add`, payload, {
    headers: { 'app-type': 'AB' },
  })
}

export const deactivatePickingFlowBranches = async payload => {
  return aludraApi.post(
    `${mdl11Urls.billingFlowPickingBranch}/deactivate`,
    payload,
    { headers: { 'app-type': 'AB' } }
  )
}
